import 'idempotent-babel-polyfill';
import WatchListPage from './WatchListPage';
import { WatchListSlideOutLink } from './components/WatchListSlideOut/WatchListSlideout';

declare var global: any;

global.WatchList = WatchListPage;
global.WatchListSlideOut = WatchListSlideOutLink;
